import React, {useState} from 'react';
import './Settings.css';
import api from '../contexts/BaseUrl';
import LeftPanel from '../components/LeftPanel';
import CrossIcon from '../icons/CrossIcon';
import {Spinner} from 'react-activity'
import "react-activity/dist/Spinner.css";
import { FaEyeSlash, FaEye } from "react-icons/fa";
import Loading from '../components/Loading';

function Settings(){
    
    const token = JSON.parse(localStorage.getItem('auth')).token;
    const userName = JSON.parse(localStorage.getItem('auth')).name;
    const userEmail = JSON.parse(localStorage.getItem('auth')).email;
    const role = JSON.parse(localStorage.getItem('auth')).role;

    const [isPasswordLoading,setIsPasswordLoading] = useState(false);
    const [isPasswordError,setIsPasswordError] = useState(false);

    //yes no params
    const [myProfile, setMyProfile] = useState(1);
    const [allUsers,setAllUsers] = useState(0);
    const [allShades,setAllShades] = useState(0);
    const [changePassword, setChangePassword] = useState(0);
    const [isPasswordChangeSuccess, setIsPasswordChangeSuccess] = useState(0);
    const [addUser,setAddUser] = useState(0);
    const [addShade,setAddShade] = useState(0);
    

    //login field params
    const [eyeOn, setEyeOn] = useState(false);
    const [eyeOnNew,setEyeOnNew] = useState(false);
    const [passwordtype, setPasswordtype] = useState('password');
    const [passwordtypeNew,setPasswordtypeNew] = useState('password');

    //add user params
    const [newUserName,setNewUserName] = useState('');
    const [newUserEmail,setNewUserEmail] = useState('');
    const [newUserPassword,setNewUserPassword] = useState('');
    const [newUserRole,setNewUserRole] = useState('');
    const [isAddNewUserError,setIsAddNewUserError] = useState(false);
    const [isAddNewUserLoading,setIsAddNewUserLoading] = useState(false);

    //password change params
    const [currentPassword,setCurrentPassword] = useState('');
    const [newPassword,setNewPassword] = useState('');

    //all user params
    const [allUsersData,setAllUsersData] = useState([]);
    const [isAllUsersLoading,setIsAllUsersLoading] = useState(false);

    const [allShadesData,setAllShadesData] = useState([]);
    const [isAllShadesLoading,setIsAllShadesLoading] = useState(false);

   //delete user params
    const [deleteUser,setDeleteUser] = useState(0);
    const [deleteUserEmail,setDeleteUserEmail] = useState('');
    const [isDeleteUserLoading,setIsDeleteUserLoading] = useState(false);
    const [isDeleteUserError,setIsDeleteUserError] = useState(false);

    // add new shade params
    const [newShadeName,setNewShadeName] = useState('');
    const [newShadeTimePeriod,setNewShadeTimePeriod] = useState('');
    const [isAddNewShadeLoading,setIsAddNewShadeLoading] = useState(false);
    const [isAddNewShadeError,setIsAddNewShadeError] = useState(false);

    //edit shade details params
    const [editShade,setEditShade] = useState(0);
    const [isShadeDetailsLoading,setIsShadeDetailsLoading] = useState(false);
    const [editShadeId,setEditShadeId] = useState(0);
    const [editShadeName,setEditShadeName] = useState('');
    const [editShadeTimePeriod,setEditShadeTimePeriod] = useState('');
    const [isEditShadeDetailsError,setIsEditShadeDetailsError]  = useState(false);
    const [isEditShadeDetailsLoading,setIsEditShadeDetailsLoading]  = useState(false);
    const [deleteShade,setDeleteShade] = useState(0);
    const [deleteShadeId,setDeleteShadeId] = useState(0);
    const [isDeleteShadeLoading,setIsDeleteShadeLoading] = useState(false);
    const [isDeleteShadeError,setIsDeleteShadeError] = useState(false);

    const handleEyeOnClick = () => {
        setEyeOn(true);
        setPasswordtype('text');
    }

    const handleEyeOffClick = () => {
        setEyeOn(false);
        setPasswordtype('password');
    }

    const handleEyeOnNewClick = () => {
        setEyeOnNew(true);
        setPasswordtypeNew('text');
    }

    const handleEyeOffNewClick = () => {
        setEyeOnNew(false);
        setPasswordtypeNew('password');
    }
   
    
    const handleProfile = () =>{
        setMyProfile(1);
        setAllUsers(0);
        setAllShades(0);
    }

    const handleAllUsers = async () =>{
        setMyProfile(0);
        setAllUsers(1);
        setAllShades(0);
       
        setIsAllUsersLoading(true);
        await api.get(`accounts/all-users`,{
            headers:{Authorization: `Bearer ${token}`}
        }).then(response =>{
            setAllUsersData(response.data);
            setIsAllUsersLoading(false);
        }).catch(err =>{
            setIsAllUsersLoading(false);
        })
    }

    const fetchAllShades = async () =>{
        setAllShades(1);
        setMyProfile(0);
        setAllUsers(0);

        setIsAllShadesLoading(true);
        await api.get(`unitshades/get-all-unit-shades`,{
            headers:{Authorization: `Bearer ${token}`}
        }).then(response =>{
            setAllShadesData(response.data);
            setIsAllShadesLoading(false);
        }).catch(err =>{
            setIsAllShadesLoading(false);
        })
    }


    const closeChangePassword = () =>{
        setChangePassword(0);
        setIsPasswordChangeSuccess(0);
        setCurrentPassword('');
        setNewPassword('');
        setNewUserName('');
        setNewUserEmail('');
        setEyeOn(false);
        setEyeOnNew(false);
        
    }

    const closeAddUser = () =>{
        setAddUser(0);
        setNewUserName('');
        setNewUserEmail('');
        setNewUserPassword('');
        setNewUserRole('');
        setEyeOn(false);
    }

    const closeDeleteUser = () => {
        setDeleteUser(0);
        setDeleteUserEmail('');
        setNewUserEmail('');
        setNewUserName('');
    }

    const closeDeleteShade = () => {
        setDeleteShade(0);
        setDeleteShadeId(0);
       
    }

    const closeAddNewShade = () => {
        setIsAddNewShadeError(false);
        setIsAddNewShadeLoading(false);
        setAddShade(0);
        setNewShadeName('');
        setNewShadeTimePeriod('');
    }

    const closeEditShade = () =>{
        setEditShade(0);
        setEditShadeId(0);
        setEditShadeName('');
        setEditShadeTimePeriod('');
        setIsEditShadeDetailsError(false);
        setIsEditShadeDetailsLoading(false);
    }

    const handleChangePassword = async (e) =>{
        e.preventDefault();
        setIsPasswordLoading(true);
        await api.post(`accounts/change-password`,{
            email: userEmail,
            currentPassword: currentPassword,
            newPassword: newPassword
        },{
            headers:{Authorization:`Bearer ${token}`}
        }).then(response =>{
            setChangePassword(0);
            setIsPasswordChangeSuccess(1);
            setIsPasswordLoading(false);
            setIsPasswordError(false);
            setCurrentPassword('');
            setNewPassword('');
        }).catch(err =>{
            setIsPasswordError(true);
            setIsPasswordLoading(false);
        })
    }

    const handleAddNewUser = async (e) => {
        e.preventDefault();
        setIsAddNewUserLoading(true);
        
        await api.post(`accounts/create-account`,{
            name: newUserName,
            email: newUserEmail,
            password: newUserPassword,
            role: newUserRole
        },{
            headers:{Authorization:`Bearer ${token}`}
        }).then(response =>{
            setIsAddNewUserLoading(false);
            setIsAddNewUserError(false);
            setAddUser(0);
            fetchAllUsers();
        }).catch(err => {
            setIsAddNewUserLoading(false);
            setIsAddNewUserError(true);
        })
    }

    const handleAddNewShade = async (e) => {
        e.preventDefault();
        setIsAddNewShadeLoading(true);
        
        await api.post(`unitshades/create-unit-shade`,{
            unitShadeName: newShadeName,
            unitShadeTimePeriod: newShadeTimePeriod          
        },{
            headers:{Authorization:`Bearer ${token}`}
        }).then(response =>{
            setIsAddNewShadeLoading(false);
            setIsAddNewShadeError(false);
            setAddShade(0);
            fetchAllShades();
        }).catch(err => {
            setIsAddNewShadeLoading(false);
            setIsAddNewShadeError(true);
        })
    }

    const handleEditShadeDetails = async (e) => {
        e.preventDefault();
        setIsEditShadeDetailsLoading(true);

        await api.post(`unitshades/edit-unit-shade`,{
            unitShadeId: editShadeId,
            unitShadeName: editShadeName,
            unitShadeTimePeriod: editShadeTimePeriod          
        },{
            headers:{Authorization:`Bearer ${token}`}
        }).then(response =>{
            setIsEditShadeDetailsLoading(false);
            setIsEditShadeDetailsError(false);
            setAddShade(0);
            setEditShade(0);
            fetchAllShades();
        }).catch(err => {
            setIsEditShadeDetailsLoading(false);
            setIsEditShadeDetailsError(true);
        })
    }

    const chooseDeleteUser = async (e) =>{
        setDeleteUserEmail(e);
        setDeleteUser(1);
    }

    const chooseDeleteShade = async (e) =>{
        setDeleteShadeId(e);
        setDeleteShade(1);
    }

    const chooseEditShade = async (e) => {
        setEditShade(1);
        setEditShadeId(e);

        fetchShadeDetails(e);
    }

    const handleDeleteUser = async () =>{
        setIsDeleteUserLoading(true);
        
        await api.post('accounts/delete-account',{
            email: deleteUserEmail
        },{
            timeout: 60000,
            headers:{Authorization:`Bearer ${token}`}
        }).then(response =>{
            setIsDeleteUserLoading(false);
            fetchAllUsers();
            setDeleteUser(0);
        }).catch(err =>{
            setIsDeleteUserLoading(false);
            setIsDeleteUserError(true);
        } )
    }

    const handleDeleteShade = async () =>{
        setIsDeleteShadeLoading(true);
        
        await api.post('unitshades/delete-unit-shade',{
            unitShadeId: deleteShadeId
        },{
            timeout: 60000,
            headers:{Authorization:`Bearer ${token}`}
        }).then(response =>{
            setIsDeleteShadeLoading(false);
            fetchAllShades();
            setDeleteShade(0);
        }).catch(err =>{
            setIsDeleteShadeLoading(false);
            setIsDeleteShadeError(true);
        } )
    }

    const fetchAllUsers = async () =>{
        setIsAllUsersLoading(true);
        await api.get(`accounts/all-users`,{
            headers:{Authorization: `Bearer ${token}`}
        }).then(response =>{
            setAllUsersData(response.data);
            setIsAllUsersLoading(false);
        }).catch(err =>{
            setIsAllUsersLoading(false);
        })
    }

    const fetchShadeDetails = async (e) => {
        setIsShadeDetailsLoading(true);
        await api.get(`unitshades/get-unit-shade-details?unitShadeId=${e}`,{
            headers:{Authorization: `Bearer ${token}`}
        }).then(response =>{
            setEditShadeName(response.data.unitShadeName);
            setEditShadeTimePeriod(response.data.unitShadeTimePeriod);
            setIsShadeDetailsLoading(false);
        }).catch(err =>{
            setIsShadeDetailsLoading(false);
       
        })
    }

    return(
        <div className='settings'>
            <LeftPanel
                tabName='settings'
            />
            <div id='rightPanel'>
                <div id='rightPanelContent'>
                    <div id='navigationBarContainer'>
                        <div style={{display:'flex'}}>
                            <div id='navItem' onClick={handleProfile} style={myProfile === 1 ? {backgroundColor:'#e35845',color:'white',fontFamily:'LexendMedium'} : { fontFamily:'LexendRegular'}}>My Profile</div>
                            {(role === 'Admin') && 
                            <>
                                <div id='navItem' onClick={handleAllUsers} style={allUsers === 1 ? {backgroundColor:'#e35845',color:'white',fontFamily:'LexendMedium'} : {fontFamily:'LexendRegular'}}>All Users</div>
                                <div id='navItem' onClick={fetchAllShades} style={allShades === 1 ? {backgroundColor:'#e35845',color:'white',fontFamily:'LexendMedium'} : {fontFamily:'LexendRegular'}}>Shades</div>
                                
                            </>
                            }
                        </div>
                        <div>
                        {(role === 'Admin') && allUsers === 1 && 
                            <button id='addUser' onClick={() => setAddUser(1)}>Add User</button>
                        }
                        {(role === 'Admin') && allShades === 1 && 
                            <button id='addUser' onClick={() => setAddShade(1)}>Add Shade</button>
                        }
                        {myProfile === 1 &&  <button id='changePassword' onClick={() => setChangePassword(1)}>Change Password</button>}
                        </div>
                    </div>
                    {myProfile === 1 &&
                    <div>
                        <div id='detailsBox'>
                            <div id='title'>Name:</div>
                            <div id='description'>{userName}</div>
                        </div>
                        <div id='detailsBox'>
                            <div id='title'>Email:</div>
                            <div id='description'>{userEmail}</div>
                        </div>
                        <div id='detailsBox'>
                            <div id='title'>Role:</div>
                            <div id='description'>{role}</div>
                        </div>
                    </div>
                    }
                    {
                        allUsers === 1 && 
                            (isAllUsersLoading ?
                            <Loading /> :
                            <table id='allUserTable'>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Role</th>
                                        <th>Actions</th>
                                        
                                    </tr>
                                </thead>
                                <tbody>
                                    {allUsersData.map((item,index) =>{
                                        return(
                                            <tr id={index} key={index}>
                                                <td>{item.user.name}</td>
                                                <td>{item.user.email}</td>
                                                <td>{item.roles[0]}</td>
                                                <td onClick={() => chooseDeleteUser(item.user.email)} style={{fontFamily:'LexendMedium',cursor:'pointer'}}>Delete</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>   
                                )    
                    }

                    {
                        allShades === 1 && 
                            (isAllShadesLoading ?
                            <Loading /> :
                            <table id='allUserTable'>
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>Shade Name</th>
                                        <th>Time Period</th>
                                        <th>Update</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {allShadesData.map((item,index) =>{
                                        return(
                                            <tr id={index} key={index}>
                                                <td>{item.unitShadeId}</td>
                                                <td>{item.unitShadeName}</td>
                                                <td>{item.unitShadeTimePeriod}</td>
                                                <td onClick={() => chooseEditShade(item.unitShadeId)} style={{fontFamily:'LexendMedium',cursor:'pointer'}}>Edit</td>
                                                <td onClick={() => chooseDeleteShade(item.unitShadeId)} style={{fontFamily:'LexendMedium',cursor:'pointer',color:'#e35845'}}>Delete</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>   
                                )    
                    }
                   
                </div>
            </div>
            {
                changePassword === 1 &&
                <>
                    <div id='darkBackground' />
                    <div id='modal'>
                        <CrossIcon 
                            size='36'
                            style={{
                                position:'absolute',
                                right:0,
                                cursor:'pointer'
                            }}
                            onClick={closeChangePassword}
                        />
                        <form id='modalContent' onSubmit={handleChangePassword}> 
                            <div id='modalName'>Change Password</div>
                            <div id='detailsBox'>
                                <div id='title'>Email:</div>
                                <div>{userEmail}</div>
                            </div>
                            <div id='detailsBox'>
                                <div id='title'>Current Password:</div>
                                <input 
                                    required
                                    id='typeInput'
                                    type={passwordtype}
                                    placeholder="Type Current Password"
                                    value={currentPassword}
                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                />
                                {!eyeOn ?
                                    <FaEyeSlash 
                                        id='eye' 
                                        onClick={handleEyeOnClick} 
                                    /> 
                                        : 
                                    <FaEye  
                                        id='eye' 
                                        onClick={handleEyeOffClick}
                                    />  
                                }
                            </div>
                            <div id='detailsBox'>
                                <div id='title'>New Password:</div>
                                <input 
                                    required
                                    id='typeInput'
                                    type={passwordtypeNew}
                                    placeholder="Type New Password"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                />
                                {!eyeOnNew ?
                                    <FaEyeSlash 
                                        id='eye' 
                                        onClick={handleEyeOnNewClick} 
                                    /> 
                                        : 
                                    <FaEye  
                                        id='eye' 
                                        onClick={handleEyeOffNewClick}
                                    />  
                                }
                            </div>
                            {isPasswordError && <div id='errorMsg'>Failed to change password!</div>}
                            {isPasswordLoading ?
                            <button id='updatePassword'><Spinner size={12} color='white' style={{display:'block', margin:'auto'}} /></button>:
                            <button id='updatePassword'>Update</button>
                            }
                        </form>
                    </div>
                </>
            }
            {
                isPasswordChangeSuccess === 1 &&
                <>
                    <div id='darkBackground' />
                    <div id='modalPassword'>
                        <CrossIcon 
                            size='36'
                            style={{
                                position:'absolute',
                                right:0,
                                cursor:'pointer'
                            }}
                            onClick={closeChangePassword}
                        />
                        <div id='modalContent'>
                            Password has been changed successfully! 
                        </div>
                    </div>
                </>
            }
            {
                addUser === 1 &&
                <>
                    <div id='darkBackground' />
                    <div id='modal'>
                        <CrossIcon 
                            size='36'
                            style={{
                                position:'absolute',
                                right:0,
                                cursor:'pointer'
                            }}
                            onClick={closeAddUser}
                        />
                        <form id='modalContent' onSubmit={handleAddNewUser}> 
                            <div id='modalName'>Add New User</div>
                            <div id='detailsBox'>
                                <div id='title'>Name:</div>
                                <input 
                                    required
                                    id='typeInput'
                                    placeholder="Type user name"
                                    onChange={(e) => setNewUserName(e.target.value)}
                                    value={newUserName}
                                />
                            </div>
                            
                            <div id='detailsBox'>
                                <div id='title'>Email:</div>
                                <input 
                                    required
                                    id='typeInput'
                                    type='email'
                                    placeholder="Type user email"
                                    onChange={(e) => setNewUserEmail(e.target.value)}
                                    value={newUserEmail}
                                />
                            </div>
                            <div id='detailsBox'>
                                <div id='title'>Password:</div>
                                <input 
                                    required
                                    id='typeInput'
                                    type={passwordtype}
                                    placeholder="Type user password"
                                    value={newUserPassword}
                                    onChange={(e) => setNewUserPassword(e.target.value)}
                                />
                                {!eyeOn ?
                                    <FaEyeSlash 
                                        id='eye' 
                                        onClick={handleEyeOnClick} 
                                    /> 
                                        : 
                                    <FaEye  
                                        id='eye' 
                                        onClick={handleEyeOffClick}
                                    />  
                                }
                            </div>
                            <div id='detailsBox'>
                                <div id='title'>Role:</div>
                                <select 
                                    id='roleSelect' 
                                    required
                                    onChange={(e) => setNewUserRole(e.target.value)}
                                    value={newUserRole}
                                >
                                    <option value=''>Choose Role</option>
                                    <option value='Manager'>Manager</option>
                                    <option value='Admin'>Admin</option>
                                </select>
                            </div>
                            
                            {isAddNewUserError && <div id='errorMsg'>Failed to add user!</div>}
                            {isAddNewUserLoading ?
                            <button id='updatePassword'><Spinner size={12} color='white' style={{display:'block', margin:'auto'}} /></button>:
                            <button id='updatePassword'>Add User</button>
                            }
                        </form>
                    </div>
                </>
            }
            {
                deleteUser === 1 && 
                <>
                    <div id='darkBackground' />
                    <div id='modalDeleteUser'> 
                        <CrossIcon 
                            size='36'
                            style={{
                                position:'absolute',
                                right:0,
                                cursor:'pointer'
                            }}
                            onClick={closeDeleteUser}
                        />
                        <div id='modalContentDeleteUser'>
                            <div>Are you sure you want to delete user with email:</div>
                            <div style={{textAlign:'center',fontFamily:'LexendMedium',marginTop:'10px',marginBottom:'20px'}}>{deleteUserEmail}</div>
                            {isDeleteUserError && <div id='errorMsg'>Failed to delete user!</div>}
                            <div id='buttonBox'>
                                {isDeleteUserLoading ? 
                                    <button id='buttonContent' style={{backgroundColor:'#008001'}}><Spinner size={10} color='white' style={{display:'block', margin:'auto'}} /></button> :
                                    <button onClick={handleDeleteUser} id='buttonContent' style={{backgroundColor:'#008001',color:'white'}}>Yes</button>
                                }

                                <button onClick={closeDeleteUser} id='buttonContent' style={{backgroundColor:'#5CE65B'}}>No</button>
                            </div>
                        </div>
                    </div>
                </>
            }

            {
                deleteShade === 1 && 
                <>
                    <div id='darkBackground' />
                    <div id='modalDeleteUser'> 
                        <CrossIcon 
                            size='36'
                            style={{
                                position:'absolute',
                                right:0,
                                cursor:'pointer'
                            }}
                            onClick={closeDeleteShade}
                        />
                        <div id='modalContentDeleteUser'>
                            <div>Are you sure you want to delete shade with Shade Id:</div>
                            <div style={{textAlign:'center',fontFamily:'LexendMedium',marginTop:'10px',marginBottom:'20px'}}>{deleteShadeId}</div>
                            {isDeleteShadeError && <div id='errorMsg'>Failed to delete shade!</div>}
                            <div id='buttonBox'>
                                {isDeleteShadeLoading ? 
                                    <button id='buttonContent' style={{backgroundColor:'#008001'}}><Spinner size={10} color='white' style={{display:'block', margin:'auto'}} /></button> :
                                    <button onClick={handleDeleteShade} id='buttonContent' style={{backgroundColor:'#008001',color:'white'}}>Yes</button>
                                }

                                <button onClick={closeDeleteShade} id='buttonContent' style={{backgroundColor:'#5CE65B'}}>No</button>
                            </div>
                        </div>
                    </div>
                </>
            }

            {
                addShade === 1 &&
                <>
                    <div id='darkBackground' />
                    <div id='modal'>
                        <CrossIcon 
                            size='36'
                            style={{
                                position:'absolute',
                                right:0,
                                cursor:'pointer'
                            }}
                            onClick={closeAddNewShade}
                        />
                        <form id='modalContent' onSubmit={handleAddNewShade}> 
                            <div id='modalName'>Add New Shade</div>
                            <div id='detailsBox'>
                                <div id='title'>Shade Name:</div>
                                <input 
                                    required
                                    id='typeInput'
                                    placeholder="Type shade name"
                                    onChange={(e) => setNewShadeName(e.target.value)}
                                    value={newShadeName}
                                />
                            </div>
                            
                            <div id='detailsBox'>
                                <div id='title'>Time Period:</div>
                                <input 
                                    required
                                    id='typeInput'
                                    placeholder="Type time period"
                                    onChange={(e) => setNewShadeTimePeriod(e.target.value)}
                                    value={newShadeTimePeriod}
                                />
                            </div>
                            
                           
                            
                            {isAddNewShadeError && <div id='errorMsg'>Failed to add shade!</div>}
                            {isAddNewShadeLoading ?
                            <button id='updatePassword'><Spinner size={12} color='white' style={{display:'block', margin:'auto'}} /></button>:
                            <button id='updatePassword'>Add Shade</button>
                            }
                        </form>
                    </div>
                </>
            }
            {
                editShade === 1 &&
                <>
                    <div id='darkBackground' />
                    <div id='modal'>
                        <CrossIcon 
                            size='36'
                            style={{
                                position:'absolute',
                                right:0,
                                cursor:'pointer'
                            }}
                            onClick={closeEditShade}
                        />
                        {isShadeDetailsLoading ? 
                        <Loading /> :    
                    
                        <form id='modalContent' onSubmit={handleEditShadeDetails}> 
                            <div id='modalName'>Edit Shade Details</div>
                            <div id='detailsBox'>
                                <div id='title'>Shade Name:</div>
                                <input 
                                    required
                                    id='typeInput'
                                    placeholder="Type shade name"
                                    onChange={(e) => setEditShadeName(e.target.value)}
                                    value={editShadeName}
                                />
                            </div>
                            
                            <div id='detailsBox'>
                                <div id='title'>Time Period:</div>
                                <input 
                                    required
                                    id='typeInput'
                                    placeholder="Type time period"
                                    onChange={(e) => setEditShadeTimePeriod(e.target.value)}
                                    value={editShadeTimePeriod}
                                />
                            </div>
                            
                           
                            
                            {isEditShadeDetailsError && <div id='errorMsg'>Failed to add shade!</div>}
                            {isEditShadeDetailsLoading ?
                            <button id='updatePassword'><Spinner size={12} color='white' style={{display:'block', margin:'auto'}} /></button>:
                            <button id='updatePassword'>Update</button>
                            }
                        </form>
                    }
                    </div>
                </>
            }
           
        </div>
    )
}

export default Settings;